import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Administrator',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Administrator',
        href: '/adm/administrator',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_admin',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'name',
        label: 'Nama',
        sortable: true,
      },
      {
        key: 'phone',
        label: 'Phone',
        sortable: true,
      },
      {
        key: 'user_name',
        label: 'User Name',
        sortable: true,
      },
      {
        key: 'email',
        label: 'Email',
        sortable: true,
      },
      {
        key: 'nama_pabrik',
        label: 'Pabrik',
      },
      {
        key: 'role',
        label: 'Role',
      },
      {
        key: 'status',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {},
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeAdministrator(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchAdministrator(context, params = null) {
    let result = await ApiGetRequest(`administrator`, params);
    return !result.error ? result.data.object : [];
  },

  async getListAdministrator({ commit, state }) {
    commit('changeAdministrator', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`administrator`, params);
    commit('changeAdministrator', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailAdministrator({ commit }, payload = null) {
    commit('changeAdministrator', {
      loading: true,
    });

    let result = await ApiGetRequest(`administrator/${payload.id}`);
    commit('changeAdministrator', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async uploadImageAdministrator({ commit, state }, payload) {
    commit('changeAdministrator', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`upload-image`, payload);
    commit('changeAdministrator', {
      loading: false,
    });

    if (!result.error) {
      commit('changeAdministrator', {
        form: {
          ...data.form,
          prod_img: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeAdministrator', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`administrator/import`, {
      items: data.import_form || [],
    });

    commit('changeAdministrator', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createAdministrator({ commit, state, dispatch }) {
    commit('changeAdministrator', {
      loading: true,
    });

    let result = await ApiPostRequest(`administrator`, state.data.form);
    commit('changeAdministrator', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateAdministrator({ commit, state, dispatch }, payload = null) {
    commit('changeAdministrator', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `administrator/${payload.id}`,
      state.data.form
    );

    commit('changeAdministrator', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteAdministrator({ commit, dispatch }, payload = null) {
    commit('changeAdministrator', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`administrator/${payload.id}`);
    commit('changeAdministrator', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
